import ReactDOM from 'react-dom';
import webRoutes from './routes/webRoutes';

const routes = webRoutes();

ReactDOM.render(routes, document.getElementById('root'));
